<div id="{{id}}-container" class="gene-drawer-component">
    <div [@displayInOut]="drawerState" class="overlay" (click)="drawerService.hide(id)"></div>
    <div class="drawer-wrapper drawer-{{ position }}" [@slideInOut]="contentState" [ngClass]="drawerState">
        <div class="drawer-header">
            <div class="drawer-title-wrapper">
                <h2 class="drawer-title">{{header}}</h2>
                <p class="drawer-subtitle">{{subheader}}</p>
            </div>
            <gene-close-icon width="24px" height="24px" fill="#1B1B1D" (click)="drawerService.hide(id)" />
        </div>
        <div class="drawer-body">
            <ng-content></ng-content>
        </div>
    </div>
</div>
